import { connect } from 'react-redux'
import { getFromSettings } from 'src/utils/helpers'

import Loadable from './Loadable'

const mapStateToProps = state => {
  return {
    brand: getFromSettings(state, 'brand', {}),
  }
}

export default connect(mapStateToProps, null)(Loadable)
